var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.$store.state.chat.editingMessage
        ? _c(
            "b-row",
            { staticClass: "message-input" },
            [
              _c(
                "b-col",
                {
                  attrs: {
                    xs: "6",
                    sm: "6",
                    md: "8",
                    lg: "10",
                    xl: "10",
                    cols: "8"
                  }
                },
                [
                  _c("base-textarea", {
                    staticClass: "message-text",
                    attrs: {
                      rows: 1,
                      "max-rows": 5,
                      placeholder: _vm.$t("chats.new-message")
                    },
                    model: {
                      value: _vm.$store.state.chat.newMessage,
                      callback: function($$v) {
                        _vm.$set(_vm.$store.state.chat, "newMessage", $$v)
                      },
                      expression: "$store.state.chat.newMessage"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "chat-input-buttons",
                  attrs: {
                    xs: "3",
                    sm: "3",
                    md: "2",
                    lg: "1",
                    xl: "1",
                    cols: "2"
                  }
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "icon-btn",
                      on: {
                        click: function($event) {
                          return _vm.$store.dispatch("chat/editMessage")
                        }
                      }
                    },
                    [_c("b-icon-check-lg", { staticClass: "icon" })],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "chat-input-buttons",
                  attrs: {
                    xs: "3",
                    sm: "3",
                    md: "2",
                    lg: "1",
                    xl: "1",
                    cols: "2"
                  }
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "icon-btn cancel",
                      on: {
                        click: function($event) {
                          return _vm.$store.commit("chat/resetMsg")
                        }
                      }
                    },
                    [_c("b-icon-x-lg", { staticClass: "icon" })],
                    1
                  )
                ]
              )
            ],
            1
          )
        : _vm.recordingAudio
        ? _c(
            "b-row",
            { staticClass: "message-input" },
            [
              _c(
                "b-col",
                {
                  attrs: {
                    xs: "6",
                    sm: "6",
                    md: "8",
                    lg: "10",
                    xl: "10",
                    cols: "8"
                  }
                },
                [
                  _c("div", { staticClass: "recorder" }, [
                    _c(
                      "span",
                      [
                        _c("b-icon-circle-fill", {
                          staticClass: "recording icon",
                          attrs: { animation: "throb" }
                        }),
                        _vm._v(_vm._s(_vm.formattedTime))
                      ],
                      1
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "chat-input-buttons",
                  attrs: {
                    xs: "3",
                    sm: "3",
                    md: "2",
                    lg: "1",
                    xl: "1",
                    cols: "2"
                  }
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "icon-btn cancel",
                      on: {
                        click: function($event) {
                          return _vm.cancelRecording()
                        }
                      }
                    },
                    [_c("b-icon-trash-fill", { staticClass: "icon" })],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "chat-input-buttons",
                  attrs: {
                    xs: "3",
                    sm: "3",
                    md: "2",
                    lg: "1",
                    xl: "1",
                    cols: "2"
                  }
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "icon-btn",
                      on: {
                        click: function($event) {
                          return _vm.sendAudio()
                        }
                      }
                    },
                    [_c("b-icon-cursor-fill", { staticClass: "icon" })],
                    1
                  )
                ]
              )
            ],
            1
          )
        : _c(
            "b-row",
            { staticClass: "message-input" },
            [
              _c(
                "b-col",
                {
                  attrs: {
                    xs: "6",
                    sm: "6",
                    md: "8",
                    lg: "10",
                    xl: "10",
                    cols: "8"
                  }
                },
                [
                  _c("base-textarea", {
                    staticClass: "message-text",
                    attrs: {
                      rows: 1,
                      "max-rows": 5,
                      placeholder: _vm.$t("chats.new-message")
                    },
                    model: {
                      value: _vm.$store.state.chat.newMessage,
                      callback: function($$v) {
                        _vm.$set(_vm.$store.state.chat, "newMessage", $$v)
                      },
                      expression: "$store.state.chat.newMessage"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "chat-input-buttons",
                  attrs: {
                    xs: "3",
                    sm: "3",
                    md: "2",
                    lg: "1",
                    xl: "1",
                    cols: "2"
                  }
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "icon-btn",
                      on: {
                        click: function($event) {
                          return _vm.$refs.fileInput.click()
                        }
                      }
                    },
                    [
                      _c("b-icon-paperclip", { staticClass: "icon" }),
                      _c("input", {
                        ref: "fileInput",
                        staticClass: "d-none",
                        attrs: { type: "file" },
                        on: {
                          change: function($event) {
                            return _vm.uploadFile($event.target.files[0])
                          }
                        }
                      })
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "chat-input-buttons",
                  attrs: {
                    xs: "3",
                    sm: "3",
                    md: "2",
                    lg: "1",
                    xl: "1",
                    cols: "2"
                  }
                },
                [
                  _vm.$store.state.chat.newMessage !== ""
                    ? _c(
                        "button",
                        {
                          staticClass: "icon-btn",
                          on: {
                            click: function($event) {
                              return _vm.sendMessage()
                            }
                          }
                        },
                        [_c("b-icon-cursor-fill", { staticClass: "icon" })],
                        1
                      )
                    : _c(
                        "button",
                        {
                          staticClass: "icon-btn",
                          on: {
                            click: function($event) {
                              return _vm.startRecording()
                            }
                          }
                        },
                        [_c("b-icon-mic-fill", { staticClass: "icon" })],
                        1
                      )
                ]
              )
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7d25bc78", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d25bc78","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/chat-interconsultations/ChatMessageInput.vue
// module id = 4009
// module chunks = 14